<div class="dropdown-wrapper">
    <ham-button
        #typeFilterButton
        class="status-filter-button"
        size="lg"
        [variant]="isFilterActive ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        data-testid="tasks-type-filter"
        (click)="openFlyout(typeFilterButton)"
    >
        <span class="filter-number" *ngIf="isFilterActive">{{ selectedTypes.length }}</span>
        {{ 'aumico_pm_tasks_type_filter_label' | i18next }}
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-content">
        <div
            *ngFor="let option of options"
            class="custom-checkbox status-option"
            [attr.data-testid]="'tasks-type-filter-' + option.value"
            (click)="toggle(option.value)"
        >
            <input type="checkbox" [checked]="draft.includes(option.value)" (click)="$event.stopPropagation(); toggle(option.value)" />
            <label>{{ option.labelKey | i18next }}</label>
        </div>
        <div class="filter-actions">
            <ham-button variant="teal" size="sm" (click)="applyFilter()">{{ 'aumico_pm_tasks_apply_filter' | i18next }}</ham-button>
            <ham-button variant="white" size="sm" (click)="clearFilter()">{{ 'aumico_pm_tasks_filter_clear' | i18next }}</ham-button>
        </div>
    </div>
</span>
